export const ShareIco = (props: any) => {
  const { onClick } = props;

  return (
    <svg
      onClick={onClick}
      className="headerIconLayout"
      xmlns="http://www.w3.org/2000/svg"
      width="34"
      height="29"
      viewBox="0 0 34 29"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.6954 0.792932C19.0726 1.0509 18.6665 1.65863 18.6665 2.33273V7.59111C13.1779 8.66513 9.0986 11.2127 6.16221 14.5686C3.00097 18.1814 1.23793 22.6439 0.365536 27.0059C0.211452 27.7763 0.616348 28.5497 1.33729 28.862C2.05823 29.1744 2.89939 28.9408 3.35606 28.3015C6.87766 23.3712 11.6757 20.8724 18.6665 20.5382V25.6661C18.6665 26.3402 19.0726 26.9479 19.6954 27.2059C20.3182 27.4638 21.035 27.3212 21.5117 26.8446L33.1783 15.1779C33.8292 14.527 33.8292 13.4718 33.1783 12.8209L21.5117 1.15422C21.035 0.677556 20.3182 0.534963 19.6954 0.792932ZM29.6428 13.9994L21.9998 21.6424V18.8327C21.9998 17.9123 21.2536 17.1661 20.3332 17.1661C14.4641 17.1661 9.65925 18.4423 5.76219 21.195C6.53793 19.6009 7.49829 18.1036 8.6708 16.7636C11.318 13.7382 15.1197 11.4278 20.5689 10.6493C21.39 10.532 21.9998 9.82881 21.9998 8.9994V6.35642L29.6428 13.9994Z"
        fill="black"
      />
    </svg>
  );
};

export const DrawerCloseIco = (props: any) => {
  const { onClick } = props;

  return (
    <svg
      className="drawerCloseIco"
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
    >
      <path
        d="M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z"
        fill="#292929"
      />
      <path
        d="M26.8059 14.5661L25.4351 13.1953L20.0004 18.63L14.5657 13.1953L13.1948 14.5661L18.6295 20.0009L13.1948 25.4356L14.5657 26.8064L20.0004 21.3717L25.4351 26.8064L26.8059 25.4356L21.3712 20.0009L26.8059 14.5661Z"
        fill="white"
      />
    </svg>
  );
};

export const NoneThumbnail = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
      <circle cx="16" cy="16" r="16" fill="#C2C2C2" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.22266 26.9343V26.4451C6.22266 23.194 12.7371 21.5562 16.0004 21.5562C19.2638 21.5562 25.7782 23.194 25.7782 26.4451V26.9312C23.1832 29.2545 19.7559 30.6673 15.9987 30.6673C12.2431 30.6673 8.81726 29.2558 6.22266 26.9343ZM20.8893 14.2229C20.8893 16.924 18.7015 19.1118 16.0004 19.1118C13.2993 19.1118 11.1115 16.924 11.1115 14.2229C11.1115 11.5218 13.2993 9.33398 16.0004 9.33398C18.7015 9.33398 20.8893 11.5218 20.8893 14.2229Z"
        fill="white"
      />
    </svg>
  );
};
